import { render, staticRenderFns } from "./ModalClient.vue?vue&type=template&id=2d5c9f4a&scoped=true&"
import script from "./ModalClient.vue?vue&type=script&lang=ts&"
export * from "./ModalClient.vue?vue&type=script&lang=ts&"
import style0 from "./ModalClient.vue?vue&type=style&index=0&id=2d5c9f4a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d5c9f4a",
  null
  
)

export default component.exports